<template>
	<!-- Component that displays a top rated review. Mainly used in the product page -->
	<div :class="['top-review-large', sizeClass, avatarClass]">
		<h2 class="level-four-heading mb-3">{{ heading }}</h2>
		<div class="review-header">
			<ximg
				:src="avatarUrl"
				:style="avatarStyle"
				:class="['pixelated avatar', avatarClass]"
				eager
				ariaLabel="avatar"
				role="img"
			/>
			<div class="review-info">
				<stars v-if="! isHype" :stars="review.rating" />
				<flames v-else :flames="review.rating" />
				<span class="user">
					<router-link
						v-if="review.user && review.user.isPublicProfile && ! review.isAnonymous"
						:to="userPath"
						class="name"
					>
						{{ review.user.username }}
					</router-link>
					<span v-else class="name">
						{{ review.user && ! review.isAnonymous ? review.user.username : 'No-Face' }}
					</span>
					<knighthood-icon v-if="review.user && review.user.knighthood > 0" />
					<template v-if="review.verifiedPurchase">
						<template v-if="! review.isHype">
							<span
								:title="tr('VERIFIED_PURCHASE')"
								class="review-verified purchase"
							/>
							<span class="icon-description">{{ tr('VERIFIED_PURCHASE') }}</span>
						</template>
						<template v-else-if="review.isHype">
							<span
								:title="tr('VERIFIED_PREPURCHASE')"
								class="review-verified hype"
							/>
							<span class="icon-description">{{ tr('VERIFIED_PREPURCHASE') }}</span>
						</template>
					</template>
				</span>
				<span v-if="review.user" class="user-level">Lvl {{ review.user.rankLevel }} {{ review.user.avatar.class.title }} </span>
			</div>
		</div>

		<div v-if="review.text" class="text-box" @click.prevent="scrollTo('#p-reviews')">
			<fixed-lines :lines="3" :bleedHeight="0.2" :useHeight="false">
				{{ this.review.text }}
			</fixed-lines>
		</div>
		<span v-if="displayProductName && review.product" class="sub-title">
			{{ review.product.name }}
		</span>
	</div>
</template>

<script>
import mq from 'mediaQuery';
import { t } from 'datastore/i18n';
import memberUtils from 'utils/member';
import { scrollTo } from 'utils';

export default {
	props: {
		heading: {
			type: String,
			default: '',
		},
		review: {
			type: Object,
		},
		isHype: {
			type: Boolean,
			default: false,
		},
		displayProductName: {
			type: Boolean,
			default: false,
		},
	},
	data () {
		return {
			mq,
		};
	},
	methods: {
		scrollTo,
		tr: t.prefix('PRODUCT.REVIEW'),
	},
	computed: {
		sizeClass () {
			if (mq.current <= mq.xs) {
				return 'review-small';
			}

			return 'review-large';
		},
		avatarStyle () {
			return memberUtils.avatarStyle(this.review);
		},
		avatarUrl () {
			return memberUtils.avatarUrl(this.review);
		},
		avatarClass () {
			if (! (this.review.user && this.review.user.avatar)) {
				return 'anonymous';
			}

			return '';
		},
		userPath () {
			return this.$router.route({
				name: 'member.achievements',
				params: {
					id: this.review.user?.id,
					name: this.review.user?.username,
				},
			});
		},
	},
};
</script>
